import React, { useContext, useEffect } from "react";
import "./style.css";
import { useTranslation } from "react-i18next";
import { LangContext } from "../../Contexts/Context";
import { Link } from "react-router-dom";
import { companyInfo } from "../../data/company";

const Nav = () => {
  const { t, i18n } = useTranslation();
  const { setLang } = useContext(LangContext);
  const { locale, setLocale } = useContext(LangContext);
  const [isScrolled, setIsScrolled] = React.useState(false);
  const localValue = localStorage.getItem("lang");

  function changeLanguage(e) {
    setLang(e.target.value);
    localStorage.setItem("lang", e.target.value);
    i18n.changeLanguage(localStorage.getItem("lang"));
  }

  useEffect(() => {
    const savedLang = localStorage.getItem("lang") || "ru";
    if (savedLang === "ru") {
      setLocale("ru");
    } else if (savedLang === "en") {
      setLocale("en");
    } else if (savedLang === "uz") {
      setLocale("uz");
    } else {
      setLocale("ru");
    }
  }, [localValue, setLocale]);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 32);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className={`n-navbar${isScrolled ? " is-scrolled" : ""}`}>
      <div className="ncont">
        <div className="nlogo">
          <Link to="/" className="brand-mark">
            <img src="/logo.jpg" alt={companyInfo.brandName} className="brand-image" />
          </Link>
        </div>

        <ul className="nav-links">
          <input type="checkbox" id="checkbox_toggle" />
          <label htmlFor="checkbox_toggle" className="hamburger">
            ☰
          </label>
          <div className="menu">
            <li className="extraselect">
              <select
                onChange={changeLanguage}
                className="form-select"
                id="lang-select"
                value={locale}
              >
                <option value="ru">{t("russian")}</option>
                <option value="en">{t("english")}</option>
                <option value="uz">{t("uzbek")}</option>
              </select>
            </li>
            <li>
              <a href="/">{t("home")}</a>
            </li>
            <li>
              <a href="#about">{t("about")}</a>
            </li>
            <li>
              <a href="#tours">{t("tours")}</a>
            </li>
            <li>
              <a href="#gallery">{t("gallery")}</a>
            </li>
            <li>
              <Link to="/contact">{t("contact")}</Link>
            </li>
            <li className="ex2">
              <select
                onChange={changeLanguage}
                className="form-select"
                id="lang-select"
                value={locale}
              >
                <option value="ru">{t("russian")}</option>
                <option value="en">{t("english")}</option>
                <option value="uz">{t("uzbek")}</option>
              </select>
            </li>
          </div>
        </ul>
      </div>
    </nav>
  );
};

export default Nav;
